/**
 * 語言切換元件 — 地球圖示 + 下拉選單
 */

import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en',    label: 'English'  },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = LANGUAGES.find(l => l.code === i18n.language) ?? LANGUAGES[0];

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        className="lang-trigger"
        onClick={() => setOpen(o => !o)}
        title={current.label}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="lang-globe">🌐</span>
        <span className="lang-current">{current.label}</span>
        <span className="lang-arrow">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <ul className="lang-dropdown" role="listbox">
          {LANGUAGES.map(l => (
            <li
              key={l.code}
              role="option"
              aria-selected={l.code === i18n.language}
              className={`lang-option${l.code === i18n.language ? ' selected' : ''}`}
              onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
            >
              {l.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
